import React from 'react';
import { styled } from "styled-components";
import { t } from 'ttag';

const Link = styled.a`
  display: block;
  text-align: center;
  
  color: #9738FF;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration-line: underline;
`;

const TermsConditions = () => {
  return (
    <Link href='https://www.easyllama.com/terms-anonymous' rel='noreferrer' target='_blank'>{t`Terms & Conditions`}</Link>
  );
};

export default TermsConditions;
